<template>
    <v-card flat tile max-width="100%" height="100%">
        <v-card-title>
            <v-img
                   @click="$store.getters.GET_AUTHORIZATION._token || $route.name.includes('main') ? null : $routerService.goTo('main')"
                   contain max-width="250"
                   class="mx-auto nitg__logo"
                   src="@/assets/logo.png"
                   alt="NITG Helpdesk Logo"></v-img>
        </v-card-title>
        <v-card-text>
            <v-list class="mt-12">
                <v-list-item-group>
                  <template v-for="(item, i) in menu">
                    <v-list-item :key="i"
                                 v-if="item.show"
                                 @click="$routerService.goTo(item.route)">
                      <v-list-item-icon class="mr-4">
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content v-text="$t(item.content)"></v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list-item-group>
            </v-list>
            <locales-component/>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "SidenavComponent",
        data() {
            return {
                items: [
                    {
                        icon: 'mdi-information',
                        content: 'sidenav.about',
                        route: 'about',
                        show: true
                    },
                    {
                        icon: 'mdi-email-edit-outline',
                        content: 'sidenav.contact',
                        route: 'contact',
                        show: true
                    },
                ]
            }
        },
        computed: {
            menu() {
                return this.items;
            }
        }
    }
</script>

<style scoped>

</style>
